<template>
  <div class="my-5" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-9' : 'px-5'">
    <v-dialog v-model="dialog.unit" 
      persistent
      width="500"
      scrollable>
      <v-card class="border-radius box-shadow" v-if="Object.keys(detailUnit).length > 0">
        <v-card-title class="body-2 text-first d-flex blue-grey lighten-5 pb-0">
          <div>
            <p class="mb-1">
              Tipe {{ detailUnit.unit_type_name }} - {{ detailUnit.unit_label}}
            </p>
            <p class="caption text-third">
              {{ detailUnit.project_name }}
            </p>
          </div>
          <v-spacer/>
          <div class="text-right">
            <p class="mb-1 text-third">
              Status
            </p>
            <p class="caption teal--text">
             Tersedia
            </p>
          </div>
        </v-card-title>
        <v-card-text class="pa-0" style="height: 700px;">
          <v-card-text class="pa-0">
            <v-carousel
              :continuous="false"
              cycle
              show-arrows-on-hover
              hide-delimiter-background
              delimiter-icon="mdi-minus"
              height="250">
              <v-carousel-item
                v-for="(item, index) in detailUnit.unit_detail.images"
                :key="index"
                :src="item"
                gradient="to top right, rgba(0, 0, 0, .5), rgba(0, 0, 0, .5)">
              </v-carousel-item>
            </v-carousel>
          </v-card-text>
          <v-card-text class="pa-0 px-2">
            <v-row class="ma-0">
              <v-col cols="6" class="pa-0">
                <v-card-title class="caption text-third">
                  Harga
                </v-card-title>
                <v-card-subtitle class="caption pb-0">
                  {{ detailUnit.unit_detail.price | price }}
                </v-card-subtitle>
              </v-col>
              <v-col cols="6" class="pa-0">
                <v-card-title class="caption text-third">
                  Luas
                </v-card-title>
                <v-card-subtitle class="d-flex caption pb-0">
                  <span>
                    Tanah : {{ detailUnit.unit_detail.area }} M<span style="font-size: 7px; position: relative; top: -3px; margin-left: 2px;">2</span>
                  </span>
                  <v-spacer/>
                  <span>
                    Bangunan : {{ detailUnit.unit_detail.building }} M<span style="font-size: 7px; position: relative; top: -3px; margin-left: 2px;">2</span>
                  </span>
                </v-card-subtitle>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider class="mx-4 my-2"/>
          <v-card-subtitle class="caption text-third py-0 pb-1">
            Keterangan
          </v-card-subtitle>
          <v-card-text class="caption text-first pb-0"
            v-html="detailUnit.unit_detail.description">
          </v-card-text>
          <v-divider class="mx-4 my-2"/>
          <v-card-subtitle class="caption text-third py-0">
            Fasilitas Privat
          </v-card-subtitle>
          <v-card-text class="pa-0 px-4">
            <v-row>
              <v-col cols="6" class="pa-0">
                <v-card-text
                  v-for="(item, index) in detailUnit.unit_detail.facility"
                  :key="index"
                  class="caption py-1 d-flex align-center"
                  v-if="index <= 5">
                  <v-icon small class="mr-1">mdi-check</v-icon>
                  {{ item.facility_name }}
                </v-card-text>
              </v-col>
              <v-col cols="6" class="pa-0">
                <v-card-text
                  v-for="(item, index) in detailUnit.unit_detail.facility"
                  :key="index"
                  class="caption py-1 d-flex align-center"
                  v-if="index > 5">
                  <v-icon small class="mr-1">mdi-check</v-icon>
                  {{ item.facility_name }}
                </v-card-text>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card-text>
        <v-divider class="mx-4 my-2"/>
        <v-card-actions class="pa-5">
          <v-spacer/>
          <v-btn
            v-if="detailUnit.unit_invoice_status === 'approved' && (user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator'))"
            outlined
            :color="style.primary"
            class="text-capitalize green--text mx-1"
            @click="dialog.unit = false; reset(detailUnit);">
            <v-icon small class="mr-1">mdi-cart-plus</v-icon>
            Buat Booking
          </v-btn>
          <v-btn
            v-if="detailUnit.unit_invoice_status === 'waiting' && (user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator'))"
            outlined
            color="red"
            class="text-capitalize red--text mx-1"
            href="/invoice" target="_blank">
            <v-icon small class="mr-1">mdi-close</v-icon>
            Belum Dibayar
          </v-btn>
          <v-btn
            outlined
            color="red"
            class="text-capitalize red--text mx-1"
            @click="dialog.unit = false">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.transaction" 
      persistent
      scrollable
      width="900">
      <v-card class="border-radius box-shadow">
        <v-card-title class="body-2 text-first d-flex blue-grey lighten-5 py-5">
          <span>
            Boking Unit
          </span>
          <v-spacer/>
          <span class="caption text-second">
            {{ detailUnit.project_name }}
          </span>
        </v-card-title>
        <v-card-text style="height: 100vh;">
          <ValidationObserver ref="observer" style="width: 100%;">
            <v-form>
              <v-row>
                <v-col cols="12" md="5" class="pb-0" :style="$vuetify.breakpoint.name === 'lg' ? 'border-right: 1px solid #eceff1;' : ''">
                  <v-text-field
                    dense
                    outlined
                    disabled
                    label="Proyek"
                    :color="style.primary"
                    prepend-inner-icon="mdi-home-outline"
                    v-model="form.project_name">
                  </v-text-field>
                  <ValidationProvider name="Pilih Unit" rules="required" v-slot="{ errors }">
                    <v-autocomplete
                      dense
                      outlined
                      label="Pilih Unit"
                      :color="style.primary"
                      clearable
                      prepend-inner-icon="mdi-home-export-outline"
                      :search-input.sync="autocomplete.unit"
                      :loading="process.auto"
                      :items="unit"
                      item-value="unit_id"
                      item-text="unit_label"
                      v-model="form.unit_id"
                      :error-messages="errors"
                      require>
                      <template v-slot:append>
                        <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>
                  <p class="caption text-first d-flex mb-2">
                    <span>
                      Informasi Pemesanan
                    </span>
                    <v-spacer/>
                    <span class="cursor-pointer" 
                      :class="!autocomplete.add ? 'light-green--text' : 'red--text'"
                      @click="!autocomplete.add ? autocomplete.add = true : autocomplete.add = false; form.user = {}; form.user_name = ''; form.user_mobilephone = ''; form.user_email = ''; form.user_ktp = '';">
                      {{ !autocomplete.add ? 'Tambah Baru' : 'Batal' }}
                    </span>
                  </p>

                  <p class="caption font-italic text-third">
                    *Jika data sudah ada silahkan pilih data pemesan, dan jika belum silahkan tambah baru.
                  </p>

                  <ValidationProvider name="Nama Pemesan" rules="required" v-slot="{ errors }">
                    <div v-if="!autocomplete.add">
                      <v-autocomplete
                        dense
                        outlined
                        label="Pilih Nama Pemesan"
                        :color="style.primary"
                        clearable
                        prepend-inner-icon="mdi-account-circle-outline"
                        :search-input.sync="autocomplete.customer"
                        :loading="process.auto"
                        :items="customer"
                        item-value="user_id"
                        item-text="user_name"
                        return-object
                        v-model="form.user"
                        v-on:change="onChange"
                        :error-messages="errors"
                        require>
                        <template v-slot:append>
                          <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                        </template>
                      </v-autocomplete>
                    </div>
                    <div v-if="autocomplete.add">
                      <v-text-field
                        dense
                        outlined
                        label="Nama Pemesan"
                        :color="style.primary"
                        prepend-inner-icon="mdi-account-circle-outline"
                        v-model="form.user_name"
                        :error-messages="errors"
                        require>
                      </v-text-field>
                    </div>
                  </ValidationProvider>
                  <ValidationProvider name="Handphone" rules="required|min:10|max:13" v-slot="{ errors }">
                    <v-text-field
                      type="number"
                      dense
                      outlined
                      label="Handphone"
                      :color="style.primary"
                      prepend-inner-icon="mdi-cellphone-basic"
                      :disabled="!autocomplete.add"
                      v-model="form.user_mobilephone"
                      :error-messages="errors"
                      require>
                    </v-text-field>
                  </ValidationProvider>
                  <ValidationProvider name="Email" rules="required|email" v-slot="{ errors }">
                    <v-text-field
                      dense
                      outlined
                      label="Email"
                      :color="style.primary"
                      prepend-inner-icon="mdi-email-outline"
                      :disabled="!autocomplete.add"
                      v-model="form.user_email"
                      :error-messages="errors"
                      require>
                    </v-text-field>
                  </ValidationProvider>
                  <ValidationProvider name="No KTP" rules="required" v-slot="{ errors }">
                    <v-text-field
                      type="number"
                      dense
                      outlined
                      label="No KTP"
                      :color="style.primary"
                      prepend-inner-icon="mdi-card-account-details-outline"
                      :disabled="!autocomplete.add"
                      v-model="form.user_ktp"
                      :error-messages="errors"
                      require>
                    </v-text-field>
                  </ValidationProvider>
                  <div class="v-input v-input--dense theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined">
                    <div class="v-input__control">
                      <div class="v-input__slot">
                        <div class="v-input__prepend-inner">
                          <div class="v-input__icon v-input__icon--prepend-inner">
                            <i aria-hidden="true" class="v-icon notranslate mdi mdi-map-marker-radius-outline theme--light"></i>
                          </div>
                        </div>
                        <fieldset aria-hidden="true">
                          <legend style="width: 0px;">
                            <span>​</span>
                          </legend>
                        </fieldset>
                        <div class="v-text-field__slot">
                          <label for="input-147" class="v-label theme--light" style="left: 0px; right: auto; position: absolute;">
                            <!-- Alamat Konsumen -->
                          </label>
                          <gmap-autocomplete placeholder="Alamat (bisa dikosongi)" :value="form.user_address" :select-first-on-enter="true" @place_changed="setPlace"></gmap-autocomplete>
                        </div>
                      </div>
                      <div class="v-text-field__details">
                        <div class="v-messages theme--light">
                          <div class="v-messages__wrapper">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p class="caption text-first">
                    Informasi Marketing
                  </p>
                  <ValidationProvider name="Pilih Marketing" rules="required" v-slot="{ errors }">
                    <v-autocomplete
                      dense
                      outlined
                      label="Pilih Marketing"
                      :color="style.primary"
                      clearable
                      prepend-inner-icon="mdi-timeline-check-outline"
                      :items="detail.marketing"
                      item-value="user_id"
                      item-text="user_name"
                      v-model="form.marketing_id"
                      :error-messages="errors"
                      require>
                      <template v-slot:append>
                        <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>
                  <!-- <v-menu
                    ref="tempo"
                    min-width="290px"
                    max-width="290px"
                    transition="scale-transition"
                    offset-y
                    :nudge-right="40"
                    :close-on-content-click="false"
                    v-model="picker.tempo">
                    <template v-slot:activator="{ on }">
                      <ValidationProvider name="Jatuh Tempo" rules="required" v-slot="{ errors }">
                        <v-text-field
                          dense
                          outlined
                          readonly
                          color="#4FC3F7"
                          prepend-inner-icon="mdi-calendar-month"
                          label="Jatuh Tempo"
                          v-model="form.duedate"
                          v-on="on"
                          :error-messages="errors"
                          require>
                        </v-text-field>
                      </ValidationProvider>
                    </template>
                    <v-date-picker 
                      color="#4FC3F7"
                      v-model="form.duedate"
                      @input="picker.tempo = false">
                    </v-date-picker>
                  </v-menu>
                  <v-menu
                    ref="pay"
                    min-width="290px"
                    max-width="290px"
                    transition="scale-transition"
                    offset-y
                    :nudge-right="40"
                    :close-on-content-click="false"
                    v-model="picker.pay">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        dense
                        outlined
                        readonly
                        color="#4FC3F7"
                        prepend-inner-icon="mdi-calendar-month"
                        label="Tanggal Bayar"
                        v-model="form.paydate"
                        v-on="on">
                      </v-text-field>
                    </template>
                    <v-date-picker 
                      color="#4FC3F7"
                      :max="form.duedate"
                      v-model="form.paydate"
                      @input="picker.pay = false">
                    </v-date-picker>
                  </v-menu> -->
                  <v-textarea
                    style="margin-top: 2px;"
                    outlined
                    clearable
                    clear-icon="mdi-cancel"
                    :color="style.primary"
                    label="Keterangan"
                    auto-grow
                    row-height="10"
                    v-model="form.desc">
                  </v-textarea>
                </v-col>
                <v-col cols="12" md="7" class="pb-0">
                  <v-row>
                    <v-col cols="4" class="py-0">
                      <p class="caption">
                        Harga Jual
                      </p>
                      <p class="caption">
                        Tipe Booking
                      </p>
                      <p class="caption mt-5" v-if="form.payment_type === 'KPR'">
                        Bank KPR
                      </p>
                      <p class="caption" style="margin-top: 45px" v-if="form.payment_type === 'KPR'">
                        Cabang Bank KPR
                      </p>
                      <p class="caption mt-9" v-if="form.payment_type === 'KPR'">
                        Nilai KPR
                      </p>
                      <p class="caption" :class="form.payment_type === 'KPR' ? 'mt-12' : ''">
                        Uang Muka
                      </p>
                      <p class="caption" :class="form.payment_type === 'KPR' ? '' : 'mt-12'">
                        Diskon
                      </p>
                      <p class="caption">
                        Booking Fee
                      </p>
                      <p class="caption" style="margin-top: 45px">
                        Total Uang Muka
                      </p>
                      <p class="caption">
                        Diangsur (berapa kali ?)
                      </p>
                      <p class="caption" style="margin-top: 45px">
                        Angsuran per Bulan
                      </p>
                      <p class="caption">
                        Biaya Lain-lain / Titipan
                      </p>
                      <p class="caption">
                        Total Bayar Konsumen
                      </p>
                      <p class="caption">
                        Tanggal Bayar
                      </p>
                    </v-col>
                    <v-col cols="1" class="py-0">
                      <p class="caption">
                        :
                      </p>
                      <p class="caption">
                        :
                      </p>
                      <p class="caption mt-5" v-if="form.payment_type === 'KPR'">
                        :
                      </p>
                      <p class="caption" style="margin-top: 45px" v-if="form.payment_type === 'KPR'">
                        :
                      </p>
                      <p class="caption mt-9" v-if="form.payment_type === 'KPR'">
                        :
                      </p>
                      <p class="caption" :class="form.payment_type === 'KPR' ? 'mt-12' : ''">
                        :
                      </p>
                      <p class="caption" :class="form.payment_type === 'KPR' ? '' : 'mt-12'">
                        :
                      </p>
                      <p class="caption">
                        :
                      </p>
                      <p class="caption" style="margin-top: 45px">
                        :
                      </p>
                      <p class="caption">
                        :
                      </p>
                      <p class="caption" style="margin-top: 45px">
                        :
                      </p>
                      <p class="caption">
                        :
                      </p>
                      <p class="caption">
                        :
                      </p>
                      <p class="caption">
                        :
                      </p>
                    </v-col>
                    <v-col cols="7" class="text-right py-0">
                      <p class="caption font-weight-bold">
                        {{ form.price_sale | price }}
                      </p>
                      <p class="mb-0">
                        <v-radio-group
                          v-model="form.payment_type"
                          row
                          dense
                          class="ma-0 pa-0">
                          <v-radio
                            :color="style.primary"
                            label="Pengajuan KPR"
                            value="KPR">
                            <template v-slot:label>
                              <div :class="form.payment_type === 'KPR' ? 'color-default font-weight-bold' : ''">Pengajuan KPR</div>
                            </template>
                          </v-radio>
                          <v-radio
                            :color="style.primary"
                            label="Cash"
                            value="Cash">
                            <template v-slot:label>
                              <div :class="form.payment_type === 'Cash' ? 'color-default font-weight-bold' : ''">Cash</div>
                            </template>
                          </v-radio>
                        </v-radio-group>
                      </p>
                      <p class="mb-0" v-if="form.payment_type === 'KPR'">
                        <ValidationProvider name="Bank KPR" rules="required" v-slot="{ errors }">
                          <v-select
                            dense
                            outlined
                            single-line
                            label="Bank KPR"
                            :color="style.primary"
                            :items="bank"
                            item-value="ref_bank_kpr_bank_id"
                            item-text="ref_bank_kpr_bank_name"
                            item-color="light-blue lighten-2"
                            v-model="form.bank_kpr"
                            :error-messages="errors"
                            require>
                            <template v-slot:append>
                              <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                            </template>
                            <template v-slot:selection="data">
                              <v-avatar left tile class="mr-2" size="40">
                                <v-img contain :src="data.item.ref_bank_kpr_bank_image"></v-img>
                              </v-avatar>
                              <span class="contain">
                                {{ data.item.ref_bank_kpr_bank_name }}
                              </span>
                            </template>
                            <template v-slot:item="data">
                              <template>
                                <v-list-item-avatar tile size="40">
                                  <v-img contain :src="data.item.ref_bank_kpr_bank_image"></v-img>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                  <v-list-item-title class="caption" v-html="data.item.ref_bank_kpr_bank_name"></v-list-item-title>
                                </v-list-item-content>
                              </template>
                            </template>
                          </v-select>
                        </ValidationProvider>
                      </p>
                      <p v-if="form.payment_type === 'KPR'">
                        <v-text-field
                          dense
                          outlined
                          label="Cabang Bank KPR (bisa dikosongi)"
                          :color="style.primary"
                          hide-details
                          v-model="form.bank_kpr_branch">
                        </v-text-field>
                      </p>
                      <p class="mb-0" v-if="form.payment_type === 'KPR'">
                        <ValidationProvider name="Nilai KPR" rules="required" v-slot="{ errors }">
                          <v-currency-field 
                            reverse
                            dense
                            outlined
                            label="Nilai KPR"
                            :color="style.primary"
                            v-model="form.price_kpr"
                            :error-messages="errors"
                            require>
                          </v-currency-field>
                        </ValidationProvider>
                      </p>
                      <!-- UANG MUKA -->
                      <p class="caption" :class="form.payment_type === 'KPR' ? '' : 'mb-0'">
                        <span class="font-weight-bold" v-if="form.payment_type === 'KPR'">
                          {{ form.price_fee | price }}
                        </span>
                        <ValidationProvider name="Uang Muka" rules="required" v-slot="{ errors }" v-if="form.payment_type === 'Cash'">
                          <v-currency-field 
                            reverse
                            dense
                            outlined
                            label="Uang Muka"
                            :color="style.primary"
                            v-model="form.price_fee"
                            :error-messages="errors"
                            require>
                          </v-currency-field>
                        </ValidationProvider>
                      </p>
                      <p class="caption font-weight-bold">
                        <v-tooltip left>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              :color="style.primary"
                              dark
                              small
                              v-bind="attrs"
                              v-on="on"
                              @click="dialog.discount = true">
                              mdi-cash-plus
                            </v-icon>
                          </template>
                          <span>Tambah Diskon</span>
                        </v-tooltip>
                        {{ calculate() | price }}
                      </p>
                      <p class="mb-0">
                        <ValidationProvider name="Booking Fee" rules="required" v-slot="{ errors }">
                          <v-currency-field 
                            reverse
                            dense
                            outlined
                            label="Booking Fee"
                            :color="style.primary"
                            v-model="form.price_booking_fee"
                            :error-messages="errors"
                            require>
                          </v-currency-field>
                        </ValidationProvider>
                      </p>
                      <!-- TOTAL UANG MUKA -->
                      <p class="caption font-weight-bold">
                        {{ form.price_fee_total | price }}
                      </p>
                      <p class="mb-0">
                        <v-row>
                          <v-col cols="7" class="caption font-weight-bold py-0 pr-1">
                            {{ form.price_fee_total | price }}
                          </v-col>
                          <v-col cols="1" class="caption py-0">
                            /
                          </v-col>
                          <v-col cols="4" class="py-0">
                            <ValidationProvider name="Angsuran" rules="required|max_60:60" v-slot="{ errors }">
                              <v-text-field 
                                reverse
                                dense
                                outlined
                                label="Angsuran"
                                :color="style.primary"
                                v-model="form.count_dp"
                                @focus="$event.target.select()"
                                :error-messages="errors"
                                require>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                      </p>
                      <p class="caption font-weight-bold">
                        <span v-if="parseInt(form.count_dp) > 0">
                          {{ (parseInt(form.price_fee_total) / parseInt(form.count_dp)) | price }}
                        </span>
                        <span v-else>
                          {{ parseInt(form.price_fee_total) | price }}
                        </span>
                      </p>
                      <p class="caption font-weight-bold">
                        <v-tooltip left>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              :color="style.primary"
                              dark
                              small
                              v-bind="attrs"
                              v-on="on"
                              @click="dialog.other = true">
                              mdi-cash-plus
                            </v-icon>
                          </template>
                          <span>Tambah Biaya Lain-lain / Titipan</span>
                        </v-tooltip>
                        {{ form.price_other.price | price }}
                      </p>
                      <!-- TOTAL BAYAR KONSUMEN -->
                      <p class="caption font-weight-bold">
                        {{ form.price_fee_customer | price }}
                      </p>
                      <p>
                        <v-menu
                          ref="pay"
                          min-width="290px"
                          max-width="290px"
                          transition="scale-transition"
                          offset-y
                          :nudge-right="40"
                          :close-on-content-click="false"
                          v-model="picker.pay">
                          <template v-slot:activator="{ on }">
                            <ValidationProvider name="Tanggal Bayar" rules="required" v-slot="{ errors }">
                              <v-text-field
                                dense
                                outlined
                                readonly
                                :color="style.primary"
                                prepend-inner-icon="mdi-calendar-month"
                                label="Tanggal Bayar"
                                v-model="form.paydate"
                                v-on="on"
                                :error-messages="errors"
                                require>
                              </v-text-field>
                            </ValidationProvider>
                          </template>
                          <v-date-picker 
                            :color="style.primary"
                            :max="form.duedate"
                            v-model="form.paydate"
                            @input="picker.pay = false">
                          </v-date-picker>
                        </v-menu>
                      </p>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </ValidationObserver>
        </v-card-text>
        <v-card-text class="pt-0 pb-0">
          <v-alert type="error" text dense prominent 
            v-show="error.message.length > 0"
            v-html="error.message">
          </v-alert>
        </v-card-text>
        <v-card-actions class="pb-5 px-6">
          <v-spacer/>
          <v-btn
            outlined
            :color="style.primary"
            class="text-capitalize green--text mx-1"
            :loading="process.run"
            :disabled="process.run"
            @click="save">
            <v-icon small class="mr-1">mdi-cart-plus</v-icon>
            Booking
          </v-btn>
          <v-btn 
            outlined 
            color="red"
            class="text-capitalize red--text"
            :disabled="process.run"
            @click="reset(); $refs.observer.reset();">
            <v-icon small class="mr-1">mdi-close-circle</v-icon>
            Batalkan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.discount" 
      persistent
      width="650">
      <v-card class="border-radius box-shadow">
        <v-card-title class="pb-0">
          <v-btn
            small
            outlined
            color="green"
            class="text-capitalize mr-2"
            @click="addDiscount()">
            Tambahkan Diskon
          </v-btn>
          <v-btn
            v-if="form.price_discount.length > 0"
            small
            outlined
            color="red"
            class="text-capitalize"
            @click="form.price_discount = []; form.discount_value = 0;">
            Hapus Semua
          </v-btn>
        </v-card-title>
        <v-divider class="mt-5 mb-2" v-if="form.price_discount.length > 0"/>
        <v-card-title class="py-0" v-if="form.price_discount.length > 0">
          <v-row
            v-for="(item, index) in form.price_discount"
            :key="index">
            <v-col cols="1">
              <div style="width: 32px;">
                <v-chip
                  class="px-0 d-flex justify-center align-center"
                  style="width: 100px; border-radius: 0px !important;"
                  label>
                  {{ index+1 }}
                </v-chip>
                <v-chip
                  style="border-radius: 0px !important;"
                  label
                  color="red"
                  class="px-1 text-center cursor-pointer"
                  @click="removeDiscount(index)">
                  <v-icon color="white">mdi-close</v-icon>
                </v-chip>
              </div>
            </v-col>
            <v-col cols="11">
              <v-row>
                <v-col cols="6" class="py-0">
                  <v-text-field
                    dense
                    outlined
                    label="Judul"
                    :color="style.primary"
                    prepend-inner-icon="mdi-text"
                    v-model="item.title">
                  </v-text-field>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-currency-field 
                    dense
                    outlined
                    label="Diskon"
                    :color="style.primary"
                    prepend-inner-icon="mdi-cash-100"
                    v-model="item.price">
                  </v-currency-field>
                </v-col>
              </v-row>

              <v-textarea
                clearable
                clear-icon="mdi-cancel"
                :color="style.primary"
                label="Keterangan"
                auto-grow
                outlined
                row-height="10"
                v-model="item.desc">
              </v-textarea>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="pa-0" v-if="form.price_discount.length < 1">
          <v-divider class="my-6"/>
          <p class="body-2 text-second text-center my-16">
            Belum ada Diskon
          </p>
          <v-divider class="my-6"/>
        </v-card-text>
        <v-card-text class="pt-0 pb-0">
          <v-alert type="error" text dense prominent 
            v-show="error.message.length > 0"
            v-html="error.message">
          </v-alert>
        </v-card-text>
        <v-card-actions class="pb-5 px-6">
          <v-spacer/>
          <v-btn
            outlined
            small
            :color="style.primary"
            class="text-capitalize green--text mx-1"
            @click="dialog.discount = false">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Simpan
          </v-btn>
          <v-btn 
            outlined 
            small
            color="red"
            class="text-capitalize red--text"
            @click="dialog.discount = false">
            <v-icon small class="mr-1">mdi-close-circle</v-icon>
            Batalkan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.other" 
      persistent
      width="650">
      <v-card class="border-radius box-shadow">
        <v-card-title class="body-2 text-first d-flex blue-grey lighten-5 py-5">
          Tambahkan Biaya Lain-lain / Titipan
        </v-card-title>
        <v-card-title class="pb-0">
          <ValidationObserver ref="observer" style="width: 100%;">
            <v-form>
              <v-row>
                <v-col cols="7" class="py-0">
                  <v-currency-field 
                    dense
                    outlined
                    label="Biaya Lain-lain / Titipan"
                    :color="style.primary"
                    prepend-inner-icon="mdi-cash-100"
                    v-model="form.price_other.price">
                  </v-currency-field>
                </v-col>
                <v-col cols="5" class="py-0">
                  <!-- <ValidationProvider name="Angsuran" rules="max_12:12" v-slot="{ errors }">
                    <v-currency-field 
                      dense
                      outlined
                      label="Angsuran"
                      color="#4FC3F7"
                      prepend-inner-icon="mdi-calendar-month"
                      v-model="form.price_other.installments"
                      @focus="$event.target.select()"
                      :error-messages="errors"
                      require>
                    </v-currency-field>
                  </ValidationProvider> -->
                </v-col>
              </v-row>

              <v-textarea
                clearable
                clear-icon="mdi-cancel"
                :color="style.primary"
                label="Keterangan"
                auto-grow
                outlined
                row-height="20"
                v-model="form.price_other.desc">
              </v-textarea>
            </v-form>
          </ValidationObserver>
        </v-card-title>
        <v-card-text class="pt-0 pb-0">
          <v-alert type="error" text dense prominent 
            v-show="error.message.length > 0"
            v-html="error.message">
          </v-alert>
        </v-card-text>
        <v-card-actions class="pb-5 px-6">
          <v-spacer/>
          <v-btn
            outlined
            small
            :color="style.primary"
            class="text-capitalize green--text mx-1"
            @click="dialog.other = false">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Simpan
          </v-btn>
          <v-btn 
            outlined 
            small
            color="red"
            class="text-capitalize red--text"
            @click="dialog.other = false">
            <v-icon small class="mr-1">mdi-close-circle</v-icon>
            Batalkan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.images" 
      persistent
      width="1000">
      <v-card class="border-radius box-shadow"
        v-if="Object.keys(detail).length > 0">
        <v-carousel
          :continuous="false"
          cycle
          height="auto"
          show-arrows-on-hover
          hide-delimiter-background
          delimiter-icon="mdi-minus">
          <v-carousel-item
            v-for="(item, index) in detail.detail.images"
            :key="index"
            :src="item"
            gradient="to top right, rgba(0, 0, 0, .5), rgba(0, 0, 0, .5)">
            <v-icon color="white" style="position: absolute; top: 15px; right: 15px;" @click="dialog.images = false">mdi-close-circle-outline</v-icon>
          </v-carousel-item>
        </v-carousel>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.map" 
      persistent
      width="1000">
      <v-card class="border-radius box-shadow"
        v-if="Object.keys(detail).length > 0">
        <v-card-title class="body-2 text-first d-flex blue-grey lighten-5 py-5">
          <span>
            Lokasi Proyek {{ detail.name }}
          </span>
          <v-spacer/>
          <span class="caption text-second">
            <v-icon color="red" @click="dialog.map = false">mdi-close-circle-outline</v-icon>
          </span>
        </v-card-title>
        <gmap-map
          :center="center"
          :zoom="15"
          :clickable="true"
          class="_maps"
          :options="{
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: true,
            disableDefaultUi: false
          }">

          <gmap-marker
            :position="center">
          </gmap-marker>
        </gmap-map>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.delete" 
      persistent
      width="400">
      <v-card class="pa-5">
        <v-card-text>
          Apakah anda yakin menghapus
          <span class="font-weight-bold">
            {{ detail.name }}
          </span>
          ?
        </v-card-text>
        <v-card-text class="pt-0 pb-0">
          <v-alert type="error" text dense prominent 
            v-show="error.message.length > 0"
            v-html="error.message">
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            small
            color="red"
            elevation="3"
            class="text-capitalize white--text mx-1"
            :loading="process.run"
            :disabled="process.run"
            @click="deletes">
            <v-icon small class="mr-1">mdi-trash-can-outline</v-icon>
            Ya, hapus
          </v-btn>
          <v-btn
            small
            outlined
            class="text-capitalize red--text mx-1"
            :disabled="process.run"
            @click="detail = {}; dialog.delete = false;">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Tidak
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.payment.upgrade" 
      persistent
      width="600">
      <v-card class="pa-5">
        <v-card-title>
          Upgrade Paket
        </v-card-title>
        <v-card-text class="line-text-second">
          Silahkan mengupgrade paket, dengan cara memilih <span class="font-italic">"paket"</span> yang tersedia, kemudian klik tombol <b>Simpan</b> di bawah ini :
        </v-card-text>
        <v-card-text>
          <ValidationObserver ref="observer">
            <v-form>
              <div class="d-flex align-start">
                <p>
                  Paket Saat Ini
                </p>
                <v-spacer/>
                <p class="font-weight-bold">
                  {{ subscribe.company_project_schema_label }}
                </p>
              </div>
              <div class="d-flex align-start">
                <p>
                  Harga Paket Saat Ini
                </p>
                <v-spacer/>
                <p class="font-weight-bold">
                  {{ parseInt(subscribe.company_project_schema_price) | price }}
                </p>
              </div>

              <div class="d-flex align-start">
                <p class="mt-2">
                  Paket Tersedia
                </p>
                <v-spacer/>
                <p class="font-weight-bold">
                  <ValidationProvider name="Pilih Paket" rules="required" v-slot="{ errors }">
                    <v-select
                      style="position: absolute; right: 44px; width: 25%;"
                      class="pt-0 mt-0"
                      dense
                      placeholder="Pilih Paket"
                      :color="style.primary"
                      :items="config.schema"
                      item-value="schema_id"
                      item-text="schema_label"
                      item-color="light-green lighten-2"
                      item-disabled="disabled"
                      v-model="payment.schema_id"
                      :error-messages="errors"
                      require>
                    </v-select>
                  </ValidationProvider>
                </p>
              </div>
              <v-alert v-if="payment.schema_id !== ''"
                outlined
                type="info"
                :color="style.primary"
                text>
                {{ payment.schema_desc }}
              </v-alert>
              <v-divider class="my-3 mb-4"/>
              <div class="d-flex align-start">
                <p class="font-weight-bold">
                  Total Tagihan
                </p>
                <v-spacer/>
                <p class="font-weight-bold">
                  <span>
                    <span v-if="payment.schema_id === ''">
                      Rp 0
                    </span>
                    <span v-else>
                      {{ (parseInt(payment.schema_price) - parseInt(subscribe.company_project_schema_price)) | price }}
                    </span>
                  </span>
                </p>
              </div>
              <p class="font-italic text-third mb-0">
                *Total tagihan merupakan perngurangan dari harga paket baru dengan paket saat ini, jadi anda cukup membayarkan sisa dari harga paket yang baru.
              </p>
            </v-form>
          </ValidationObserver>
        </v-card-text>
        <v-card-text class="pt-0 pb-0">
          <v-alert type="error" text dense prominent 
            v-show="error.message.length > 0"
            v-html="error.message">
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            small
            :color="style.primary"
            elevation="3"
            class="text-capitalize white--text mx-1"
            :loading="process.upgrade"
            :disabled="process.upgrade"
            @click="upgrade">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Simpan
          </v-btn>
          <v-btn
            small
            outlined
            class="text-capitalize red--text mx-1"
            :disabled="process.upgrade"
            @click="dialog.payment.upgrade = false">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Tidak
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-row justify="center" align="center" style="min-height: 800px;" v-if="Object.keys(detail).length < 1">
      <v-col cols="12" class="d-flex align-center">
        <v-card flat class="ma-auto">
          <v-card-title class="justify-center">
            <v-progress-circular
              :size="70"
              :width="7"
              color="grey"
              indeterminate>
            </v-progress-circular>
          </v-card-title>
          <v-card-text class="subtitle-1 text-center text-second">
            Loading
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    
    <v-row v-if="Object.keys(detail).length > 0">
      <v-col cols="12" md="3">
        <v-card
          class="border-radius box-shadow">
          <v-carousel
            :continuous="false"
            cycle
            show-arrows-on-hover
            hide-delimiter-background
            delimiter-icon="mdi-minus"
            height="250">
            <v-carousel-item
              v-for="(item, index) in detail.detail.images"
              :key="index"
              :src="item"
              gradient="to top right, rgba(0, 0, 0, .5), rgba(0, 0, 0, .5)">
              <v-icon color="white" style="position: absolute; top: 10px; right: 10px;" @click="dialog.images = true">mdi-arrow-expand-all</v-icon>
            </v-carousel-item>
          </v-carousel>
          <v-card-text class="pb-0">
            <v-btn
              color="#B2B2B2"
              outlined
              x-small
              rounded
              class="text-capitalize d-flex align-center">
              <v-icon small class="mr-1">mdi-home-variant-outline</v-icon>
              {{ detail.company_name }}
            </v-btn>
          </v-card-text>
          <v-card-title class="subtitle-1 text-first">
            {{ detail.name }}
          </v-card-title>
          <v-card-subtitle class="caption text-second line-text-second">
            {{ detail.address }}
            <p class="mb-0">
              {{ detail.city_name }}, {{ detail.province_name }}
            </p>
          </v-card-subtitle>
          <v-card-title class="font-weight-bold text-first py-0" style="font-size: 10px;">
            <span>
              Rentang Harga Jual
            </span>
            <v-spacer/>
            <span>
              {{ parseInt(detail.min_price) | price }} ~ {{ parseInt(detail.max_price) | price }}
            </span>
          </v-card-title>
          <v-divider class="mx-2"/>
          <v-card-text class="px-2">
            <v-simple-table dense fixed-header :height="detail.unit_type.length > 4 ? '175px' : ''">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left pl-2" style="font-size: 10px;" width="170">Tipe Unit</th>
                    <th class="text-center px-1" style="font-size: 10px;">Jml</th>
                    <th class="text-center px-1" style="font-size: 10px;">Tersedia</th>
                    <th class="text-center px-1" style="font-size: 10px;">Booking</th>
                    <th class="text-center px-1" style="font-size: 10px;">Proses</th>
                    <th class="text-center px-1" style="font-size: 10px;">PPJB</th>
                    <th class="text-center px-1" style="font-size: 10px;">AJB</th>
                  </tr>
                </thead>
                <tbody>
                  <tr 
                    v-for="(item, index) in detail.unit_type" 
                    :key="index">
                    <td class="text-second pl-2" style="font-size: 10px;">{{ item.unit_type_name }}</td>
                    <td class="text-second text-center px-1" style="font-size: 10px;">{{ item.unit_type_total_unit }}</td>
                    <td class="teal--text text-center px-1" style="font-size: 10px;">{{ item.total_unit_available }}</td>
                    <td class="green--text text-center px-1" style="font-size: 10px;">{{ item.total_unit_booking }}</td>
                    <td class="red--text text-center px-1" style="font-size: 10px;">{{ item.unit_type_sold_unit }}</td>
                    <td class="orange--text text-center px-1" style="font-size: 10px;">{{ item.total_unit_ppbj }}</td>
                    <td class="purple--text text-center px-1" style="font-size: 10px;">{{ item.total_unit_ajb }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          <v-card-title class="font-weight-bold text-first py-0" style="font-size: 10px;">
            Rentang Penjualan
          </v-card-title>
          <v-divider class="mx-2"/>
          <v-card-text class="px-2">
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr 
                    v-for="(item, index) in detail.sales" 
                    :key="index">
                    <td class="text-second pl-2" style="font-size: 10px;">{{ item.status }}</td>
                    <td class="text-second text-center px-0" :class="`${item.color}--text`" style="font-size: 10px;">{{ item.count }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          <v-card-actions class="py-3" v-if="user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator')">
          <!-- <v-card-actions class="py-3" v-if="(user.role === 'superuser' || user.role === 'administrator') && detail.company_is_active === '1'"> -->
            <v-row>
              <v-col :cols="$vuetify.breakpoint.name === 'xs' ? 6:6" md="6" class="py-0">
                <v-btn
                  :color="style.primary"
                  small
                  outlined
                  block
                  class="text-capitalize"
                  :to="`/project/update/${detail.id}`">
                  <v-icon small class="mr-1">mdi-pencil-outline</v-icon>
                  Ubah
                </v-btn>
              </v-col>
              <v-col :cols="$vuetify.breakpoint.name === 'xs' ? 6:6" md="6" class="py-0">
                <v-btn
                  color="red"
                  small
                  outlined
                  block
                  class="text-capitalize"
                  @click="dialog.delete = true">
                  <v-icon small class="mr-1">mdi-trash-can-outline</v-icon>
                  Hapus
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" md="9">
        <v-card-text class="pa-0">
          <v-btn-toggle
            borderless
            mandatory
            style="border-radius: 5px 5px 0px 0px;"
            v-model="selected.menu">
            <v-btn
              v-for="(item, index) in menu"
              :key="index"
              height="40"
              width="150"
              :color="selected.menu === index ? '#212121' : '#e2e2e2'"
              class="caption text-capitalize"
              :class="selected.menu === index ? 'white--text' : ''">
              {{ item }}
            </v-btn>
          </v-btn-toggle>
        </v-card-text>

        <!-- TIPE UNIT -->
        <v-card
          min-height="795"
          class="border-radius box-shadow"
          style="border-radius: 0px 10px 10px 10px !important;"
          v-if="selected.menu < 1">
          <v-card-subtitle class="caption text-third pb-0">
            Pilih Tipe Unit
          </v-card-subtitle>
          <v-card-text>
            <v-select
              outlined
              dense
              single-line
              :hide-details="true"
              label="Semua Tipe Unit"
              :items="detail.unit_filter"
              item-text="unit_type_name"
              item-value="unit_type_id"
              item-color="light-green lighten-2"
              v-model="filter.type">
              <template v-slot:append>
                <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
              </template>
            </v-select>
          </v-card-text>
          <v-card-text class="py-0">
            <v-tabs
              v-model="selected.subMenu"
              background-color="transparent"
              color="#7B7B7B"
              slider-size="4">
              <v-tabs-slider color="#333333"></v-tabs-slider>
              <v-tab
                v-for="(item, index) in subMenu"
                :key="index"
                class="text-capitalize">
                <span class="body-2" :class="selected.subMenu === index ? 'font-weight-bold text-second' : 'text-third'">
                  {{ item }}
                </span>
                <span class="text-third mx-1" style="font-size: 10px;">
                  ({{ index === 0 ? totalpage.unit : index === 1 ? totalpage.transaction : totalpage.cancel }})
                </span>
              </v-tab>
            </v-tabs>
            <v-divider/>
          </v-card-text>
          
          <!-- AVAILABLE -->
          <div v-if="selected.subMenu === 0">
            <v-row class="px-4">
              <v-col cols="12" sm="6" :style="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 'padding-bottom: 0px !important':''">
                <v-text-field
                  outlined
                  dense
                  :hide-details="true"
                  placeholder="Nama unit . . ."
                  clearable
                  :color="style.primary"
                  v-model="filter.title"
                  @click:clear="filter.title = ''; fetchUnit();"
                  v-on:keyup.enter="fetchUnit()"
                  prepend-inner-icon="mdi-magnify">
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" :class="$vuetify.breakpoint.name === 'xs' ? 'pb-0 mt-2':'text-right'" :order="$vuetify.breakpoint.name === 'xs' ? 'first':''">
                <v-btn v-if="(user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator')) && pagination.unit.total_data > 0 && detail.company_is_active === '1'"
                  :color="style.primary"
                  elevation="3"
                  class="text-capitalize white--text"
                  @click="reset()">
                  <v-icon small class="mr-1">mdi-cart-plus</v-icon>
                  Buat Booking
                </v-btn>
                <v-btn v-if="(user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator')) && pagination.unit.total_data < 1"
                  :color="style.primary"
                  elevation="3"
                  class="text-capitalize white--text"
                  :to="`/project/unit/detail/${detail.id}`">
                  <v-icon small class="mr-1">mdi-plus</v-icon>
                  Buat Unit
                </v-btn>
              </v-col>
            </v-row>
            <v-divider class="mx-4"/>
            <v-card-text class="py-0">
              <v-skeleton-loader
                class="ma-auto"
                min-height="525"
                :loading="process.run"
                transition="scale-transition"
                :tile="false"
                type="table">
                <v-simple-table :style="pagination.unit.total_page > 0 ? 'min-height: 525px;' : ''">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left px-0" width="170">Nama Unit</th>
                        <th class="text-right px-0">Harga</th>
                        <th class="text-right px-0">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr 
                        v-for="(item, index) in process.run ? 7 : list.unit" 
                        :key="index">
                        <td class="text-second px-0">
                          <v-list-item class="pa-0">
                            <v-list-item-avatar tile class="rounded mr-2" size="50"
                              v-if="item.unit_detail.images.length > 0">
                              <v-img
                                :src="item.unit_detail.images[0]">
                              </v-img>
                            </v-list-item-avatar>
                            <v-list-item-avatar tile color="#E0E0E0" size="50" class="text-second rounded ma-auto mr-2 my-2 d-flex align-center justify-center"
                              v-if="item.unit_detail.images.length < 1">
                              {{ item.unit_type_name | initial }}
                            </v-list-item-avatar>

                            <v-list-item-content>
                              <v-list-item-title class="caption text-second mb-1">
                                <span class="text-third">{{ item.unit_type_name }}</span> - {{ item.unit_label }}
                              </v-list-item-title>
                              <v-list-item-subtitle class="text-third" style="font-size: 10px;">
                                {{ item.unit_detail.area }} 
                                M<span style="font-size: 7px; position: relative; top: -3px; margin-left: 2px;">2</span> | 
                                {{ item.unit_detail.building }} 
                                M<span style="font-size: 7px; position: relative; top: -3px; margin-left: 2px;">2</span>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </td>
                        <td class="caption text-second text-right px-0">{{ item.unit_detail.price | price }}</td>
                        <td class="orange--text text-right px-0">
                          
                          <!-- JIKA MASIH AKTIF -->
                          <div v-if="item.company_project_is_active === '1'">
                            <v-btn 
                              v-if="item.unit_invoice_status === 'approved' && (user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator'))"
                              small
                              width="140"
                              outlined
                              :color="style.primary"
                              class="text-capitalize green--text mx-1"
                              @click="reset(item)">
                              <v-icon small class="mr-1">mdi-cart-plus</v-icon>
                              Buat Booking
                            </v-btn>
                            <v-btn 
                              v-if="item.unit_invoice_status === 'waiting' && (user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator'))"
                              small
                              width="140"
                              outlined
                              color="red"
                              class="text-capitalize red--text mx-1"
                              href="/invoice" target="_blank">
                              <v-icon small class="mr-1">mdi-close</v-icon>
                              Belum Dibayar
                            </v-btn>
                            <v-btn
                              small
                              outlined
                              color="grey"
                              class="text-capitalize green--text mx-1"
                              @click="dialog.unit = true; detailUnit = item;">
                              <v-icon small class="mr-1">mdi-information-outline</v-icon>
                              Info Unit
                            </v-btn>
                          </div>

                          <!-- JIKA SUDAH HABIS MASA AKTIF & BELUM BAYAR -->
                          <div v-if="item.company_project_is_active === '0' && item.unit_invoice_status === 'waiting'">
                            <v-btn 
                              v-if="item.unit_invoice_status === 'waiting' && (user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator'))"
                              small
                              width="140"
                              outlined
                              color="red"
                              class="text-capitalize red--text mx-1"
                              href="/invoice" target="_blank">
                              <v-icon small class="mr-1">mdi-close</v-icon>
                              Belum Dibayar
                            </v-btn>
                            <v-btn
                              small
                              outlined
                              color="grey"
                              class="text-capitalize green--text mx-1"
                              @click="dialog.unit = true; detailUnit = item;">
                              <v-icon small class="mr-1">mdi-information-outline</v-icon>
                              Info Unit
                            </v-btn>
                          </div>

                          <!-- JIKA SUDAH HABIS MASA AKTIF & BELUM BAYAR -->
                          <div v-if="item.company_project_is_active === '0' && item.unit_invoice_status === 'rejected'">
                            <span class="red--text font-weight-bold">
                              Pembayaran Ditolak
                            </span>
                          </div>

                          <!-- JIKA SUDAH HABIS MASA AKTIF & SUDAH BAYAR -->
                          <div v-if="item.company_project_is_active === '0' && item.unit_invoice_status === 'approved'">
                            <span class="red--text font-weight-bold">
                              Langganan Habis
                            </span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-skeleton-loader>
              <v-row justify="center" align="center" v-if="!process.run && pagination.unit.total_page < 1">
                <v-col cols="12" class="d-flex align-center my-12">
                  <v-img 
                    class="my-12"
                    contain
                    width="200"
                    height="200"
                    :src="require('../../../assets/404/404.svg')">
                  </v-img>
                </v-col>
              </v-row>
              <v-divider style="margin-top:3px;"/>
            </v-card-text>
            <v-card-text>
              <v-row justify="end" align="center" v-if="pagination.unit.total_page > 1">
                <v-col cols="12" md="2" class="d-flex align-center justify-end">
                  <v-btn
                    :color="style.primary"
                    :disabled="pagination.unit.current === 1"
                    elevation="3"
                    min-width="36"
                    class="text-capitalize white--text px-0 mr-3"
                    @click="selected.pagination.unit = 1">
                    <v-icon>mdi-chevron-double-left</v-icon>
                  </v-btn>
                  <v-btn
                    color="#263238"
                    :disabled="pagination.unit.current < 2"
                    elevation="3"
                    min-width="36"
                    class="text-capitalize white--text px-0"
                    @click="selected.pagination.unit = selected.pagination.unit-1">
                    <v-icon>mdi-chevron-left</v-icon>
                  </v-btn>
                  <div class="mx-5" style="width: 75px;">
                    <v-autocomplete
                      v-model="selected.pagination.unit"
                      :items="pagination.unit.detail"
                      color="#263238"
                      auto-select-first
                      outlined
                      dense
                      single-line
                      hide-details
                      hide-selected>
                      <template v-slot:selection="{ item }">
                        {{ item }}
                      </template>
                    </v-autocomplete>
                  </div>
                  <v-btn
                    color="#263238"
                    elevation="3"
                    min-width="36"
                    class="text-capitalize white--text px-0"
                    :disabled="pagination.unit.current >= pagination.unit.total_page"
                    @click="selected.pagination.unit = selected.pagination.unit+1">
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-btn>
                  <v-btn
                    :color="style.primary"
                    :disabled="pagination.unit.current === pagination.unit.total_page"
                    elevation="3"
                    min-width="36"
                    class="text-capitalize white--text px-0 ml-3"
                    @click="selected.pagination.unit = pagination.unit.total_page">
                    <v-icon>mdi-chevron-double-right</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </div>

          <!-- TRANSACTION -->
          <div v-if="selected.subMenu === 1">
            <v-card-text>
              <v-row>
                <v-col cols="12" md="3" :class="$vuetify.breakpoint.name === 'xs' ? 'pb-0':'py-0'">
                  <v-text-field
                    outlined
                    dense
                    :hide-details="true"
                    placeholder="Nama unit, konsumen . . ."
                    clearable
                    :color="style.primary"
                    v-model="filter.title"
                    @click:clear="filter.title = ''; fetchTransaction();"
                    v-on:keyup.enter="fetchTransaction()"
                    prepend-inner-icon="mdi-magnify">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3" :class="$vuetify.breakpoint.name === 'xs' ? 'pb-0':'py-0'">
                  <v-select
                    dense
                    outlined
                    :items="[
                      {
                        label: 'Semua',
                        value: ''
                      },
                      {
                        label: 'Menunggu Konfirmasi Supervisor',
                        value: '1'
                      },
                      {
                        label: 'Disetujui',
                        value: '0'
                      }
                    ]"
                    item-text="label"
                    item-value="value"
                    item-color="light-green lighten-2"
                    v-model="filter.discount"
                    v-on:change="fetchTransaction()"
                    label="Status Pengajuan Booking"
                    :color="style.primary"
                    hide-details>
                    <template v-slot:append>
                      <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" md="3" :class="$vuetify.breakpoint.name === 'xs' ? 'pb-0':'py-0'">
                  <v-select
                    dense
                    outlined
                    :items="[
                      {
                        label: 'Semua',
                        value: ''
                      },
                      {
                        label: 'Belum Bayar',
                        value: 'open'
                      },
                      {
                        label: 'Sudah Bayar',
                        value: 'close'
                      }
                    ]"
                    item-text="label"
                    item-value="value"
                    item-color="light-green lighten-2"
                    v-model="filter.down_payment"
                    v-on:change="fetchTransaction()"
                    label="Status Down Payment"
                    :color="style.primary"
                    hide-details>
                    <template v-slot:append>
                      <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" md="3" :class="$vuetify.breakpoint.name === 'xs' ? 'pb-0':'py-0'">
                  <v-select
                    dense
                    outlined
                    :items="[
                      {
                        label: 'Semua',
                        value: ''
                      },
                      {
                        label: 'Pengajuan KPR',
                        value: 'Pengajuan KPR'
                      },
                      {
                        label: 'Pemberkasan',
                        value: 'Pemberkasan'
                      },
                      {
                        label: 'Wawancara',
                        value: 'Wawancara'
                      },
                      {
                        label: 'SP3K',
                        value: 'SP3K'
                      },
                      {
                        label: 'Akad',
                        value: 'Akad'
                      }
                    ]"
                    item-text="label"
                    item-value="value"
                    item-color="light-green lighten-2"
                    v-model="filter.mortage"
                    v-on:change="fetchTransaction()"
                    label="Status Dokumen"
                    :color="style.primary"
                    hide-details>
                    <template v-slot:append>
                      <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="mx-4"/>
            <v-card-text class="py-0">
              <v-skeleton-loader
                class="ma-auto"
                min-height="525"
                :loading="process.run"
                transition="scale-transition"
                :tile="false"
                type="table">
                <v-simple-table :style="pagination.transaction.total_page > 0 ? 'min-height: 525px;' : ''">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left pl-0" width="170">Konsumen</th>
                        <th class="text-left">Nama Unit</th>
                        <th class="text-left">Booking</th>
                        <th class="text-left" width="170">Down Payment</th>
                        <th class="text-left">Proses KPR / Cash</th>
                        <th class="text-left">Pembangunan</th>
                        <th class="text-right px-0">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr 
                        v-for="(item, index) in process.run ? 7 : list.transaction" 
                        :key="index">
                        <td class="text-second pl-0">
                          <v-list-item class="pa-0">
                            <v-list-item-avatar color="#E0E0E0" tile size="50" class="text-second rounded ma-auto mr-2 my-2 d-flex align-center justify-center">
                              {{ item.place_order_user_name | initial }}
                            </v-list-item-avatar>

                            <v-list-item-content>
                              <v-list-item-title class="caption text-second mb-1">
                                {{ item.place_order_user_name | title }}
                              </v-list-item-title>
                              <v-list-item-subtitle class="text-third" style="font-size: 10px;">
                                {{ item.place_order_user_mobilephone }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </td>
                        <td class="caption text-second">
                          <v-list-item class="pa-0">
                            <v-list-item-content>
                              <v-list-item-title class="caption text-second mb-1">
                                {{ item.unit_label }}
                              </v-list-item-title>
                              <v-list-item-subtitle class="text-third" style="font-size: 10px;">
                                {{ parseInt(item.unit_price) | price }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </td>
                        <td class="caption text-second">
                          <v-list-item class="pa-0">
                            <v-list-item-content>
                              <v-list-item-title class="caption red--text mb-1" v-if="item.booking_status === 'open'">
                                Jatuh Tempo
                              </v-list-item-title>
                              <v-list-item-title class="caption green--text mb-1" v-if="item.booking_status === 'close'">
                                Lunas
                              </v-list-item-title>
                              <v-list-item-subtitle class="text-third" style="font-size: 10px;" v-if="item.booking_status === 'open'">
                                {{ item.booking_due_date | date }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle class="text-third" style="font-size: 10px;" v-if="item.booking_status === 'close'">
                                {{ item.booking_closing_datetime | date }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </td>
                        <td class="caption text-second">
                          <v-list-item class="pa-0">
                            <v-list-item-content v-if="Object.keys(item.transaction_down_payment_status).length < 1">
                              <v-list-item-title class="caption text-third mb-1">
                                -
                              </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-content v-if="Object.keys(item.transaction_down_payment_status).length > 0">
                              <v-list-item-title class="caption orange--text mb-1">
                                {{ parseInt(item.transaction_down_payment_status.cash_tempo_value) | price }}
                              </v-list-item-title>
                              <v-list-item-subtitle class="text-third" style="font-size: 10px;">
                                Jatuh Tempo - {{ item.transaction_down_payment_status.cash_tempo_due_date | date }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </td>
                        <td class="caption text-second">
                          <v-list-item class="pa-0" v-if="item.transaction_payment_type === 'KPR'">
                            <v-list-item-content>
                              <v-list-item-title class="caption teal--text mb-1">
                                {{ item.status_mortage ? item.status_mortage : '-' }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <span v-if="item.transaction_payment_type === 'Cash'">
                            {{ item.transaction_payment_type }}
                          </span>
                        </td>
                        <td class="caption text-second">
                          <v-list-item class="pa-0">
                            <v-list-item-content>
                              <v-list-item-title class="caption red--text mb-1">
                                {{ item.status_developer ? item.status_developer : '-' }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </td>
                        <td class="orange--text text-right px-0">
                          <!-- JIKA MASIH AKTIF -->
                          <div v-if="item.company_project_is_active === '1'">
                            <!-- <v-btn
                              v-if="index > 0"
                              small
                              outlined
                              color="orange"
                              class="text-capitalize orange--text mx-1">
                              <v-icon small class="mr-1">mdi-cash-plus</v-icon>
                              Buat Transaksi
                            </v-btn> -->
                            <v-btn v-if="item.transaction_status_discount_review === '0'"
                              small
                              width="180"
                              outlined
                              color="purple"
                              class="text-capitalize purple--text mx-1"
                              :to="`/project/unit/transaction/booking/${item.booking_id}?transaction=${item.transaction_id}&unit=${item.unit_id}`">
                              <v-icon small class="mr-1">mdi-file-clock-outline</v-icon>
                              Kelola Transaksi
                            </v-btn>
                            <span class="color-default font-weight-bold" 
                              v-if="item.transaction_status_discount_review === '1' && (user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('supervisor'))">
                              Menunggu Konfirmasi
                            </span>
                            <v-btn v-if="item.transaction_status_discount_review === '1' && (user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('supervisor'))"
                              small
                              width="180"
                              outlined
                              color="#4FC3F7"
                              class="text-capitalize color-default mx-1"
                              :to="`/project/unit/transaction/booking/${item.booking_id}?transaction=${item.transaction_id}&unit=${item.unit_id}`">
                              <v-icon small class="mr-1">mdi-clock-outline</v-icon>
                              Menunggu Konfirmasi
                            </v-btn>
                          </div>

                          <!-- JIKA SUDAH HABIS MASA AKTIF -->
                          <div v-if="item.company_project_is_active === '0'">
                            <span class="red--text font-weight-bold">
                              Langganan Habis
                            </span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-skeleton-loader>
              <v-row justify="center" align="center" v-if="!process.run && pagination.transaction.total_page < 1">
                <v-col cols="12" class="d-flex align-center my-12">
                  <v-img 
                    class="my-12"
                    contain
                    width="200"
                    height="200"
                    :src="require('../../../assets/404/404.svg')">
                  </v-img>
                </v-col>
              </v-row>
              <v-divider style="margin-top:3px;"/>
            </v-card-text>
            <v-card-text>
              <v-row justify="end" align="center" v-if="pagination.transaction.total_page > 1">
                <v-col cols="12" md="2" class="d-flex align-center justify-end">
                  <v-btn
                    :color="style.primary"
                    :disabled="pagination.transaction.current === 1"
                    elevation="3"
                    min-width="36"
                    class="text-capitalize white--text px-0 mr-3"
                    @click="selected.pagination.transaction = 1">
                    <v-icon>mdi-chevron-double-left</v-icon>
                  </v-btn>
                  <v-btn
                    color="#263238"
                    :disabled="pagination.transaction.current < 2"
                    elevation="3"
                    min-width="36"
                    class="text-capitalize white--text px-0"
                    @click="selected.pagination.transaction = selected.pagination.transaction-1">
                    <v-icon>mdi-chevron-left</v-icon>
                  </v-btn>
                  <div class="mx-5" style="width: 75px;">
                    <v-autocomplete
                      v-model="selected.pagination.transaction"
                      :items="pagination.transaction.detail"
                      color="#263238"
                      auto-select-first
                      outlined
                      dense
                      single-line
                      hide-details
                      hide-selected>
                      <template v-slot:selection="{ item }">
                        {{ item }}
                      </template>
                    </v-autocomplete>
                  </div>
                  <v-btn
                    color="#263238"
                    elevation="3"
                    min-width="36"
                    class="text-capitalize white--text px-0"
                    :disabled="pagination.transaction.current >= pagination.transaction.total_page"
                    @click="selected.pagination.transaction = selected.pagination.transaction+1">
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-btn>
                  <v-btn
                    :color="style.primary"
                    :disabled="pagination.transaction.current === pagination.transaction.total_page"
                    elevation="3"
                    min-width="36"
                    class="text-capitalize white--text px-0 ml-3"
                    @click="selected.pagination.transaction = pagination.transaction.total_page">
                    <v-icon>mdi-chevron-double-right</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </div>

          <!-- CANCEL -->
          <div v-if="selected.subMenu === 2">
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6" :class="$vuetify.breakpoint.name === 'xs' ? 'pb-0':'py-0'">
                  <v-text-field
                    outlined
                    dense
                    :hide-details="true"
                    placeholder="Nama unit, konsumen . . ."
                    clearable
                    :color="style.primary"
                    v-model="filter.title"
                    @click:clear="filter.title = ''; fetchCancel();"
                    v-on:keyup.enter="fetchCancel()"
                    prepend-inner-icon="mdi-magnify">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6" :class="$vuetify.breakpoint.name === 'xs' ? 'pb-0':'py-0 text-right'">
                  <v-btn
                    color="teal"
                    elevation="3"
                    class="text-capitalize white--text"
                    :disabled="process.form"
                    :loading="process.form"
                    @click="prints()">
                    <v-icon small class="mr-1">mdi-microsoft-excel</v-icon>
                    Print Excel
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="mx-4"/>
            <v-card-text class="py-0">
              <v-skeleton-loader
                class="ma-auto"
                min-height="525"
                :loading="process.run"
                transition="scale-transition"
                :tile="false"
                type="table">
                <v-simple-table :style="pagination.cancel.total_page > 0 ? 'min-height: 525px;' : ''">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left pl-0" width="170">Konsumen</th>
                        <th class="text-left">Nama Unit</th>
                        <th class="text-left">Booking</th>
                        <th class="text-left" width="170">Down Payment</th>
                        <th class="text-left">Proses KPR / Cash</th>
                        <th class="text-left">Pembangunan</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr 
                        v-for="(item, index) in process.run ? 7 : list.cancel" 
                        :key="index">
                        <td class="text-second pl-0">
                          <v-list-item class="pa-0">
                            <v-list-item-avatar color="#E0E0E0" tile size="50" class="text-second rounded ma-auto mr-2 my-2 d-flex align-center justify-center">
                              {{ item.place_order_user_name | initial }}
                            </v-list-item-avatar>

                            <v-list-item-content>
                              <v-list-item-title class="caption text-second mb-1">
                                {{ item.place_order_user_name | title }}
                              </v-list-item-title>
                              <v-list-item-subtitle class="text-third" style="font-size: 10px;">
                                {{ item.place_order_user_mobilephone }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </td>
                        <td class="caption text-second">
                          <v-list-item class="pa-0">
                            <v-list-item-content>
                              <v-list-item-title class="caption text-second mb-1">
                                {{ item.unit_label }}
                              </v-list-item-title>
                              <v-list-item-subtitle class="text-third" style="font-size: 10px;">
                                {{ parseInt(item.unit_price) | price }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </td>
                        <td class="caption text-second">
                          <v-list-item class="pa-0">
                            <v-list-item-content>
                              <v-list-item-title class="caption red--text mb-1" v-if="item.booking_status === 'open'">
                                Jatuh Tempo
                              </v-list-item-title>
                              <v-list-item-title class="caption green--text mb-1" v-if="item.booking_status === 'close'">
                                Lunas
                              </v-list-item-title>
                              <v-list-item-subtitle class="text-third" style="font-size: 10px;" v-if="item.booking_status === 'open'">
                                {{ item.booking_due_date | date }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle class="text-third" style="font-size: 10px;" v-if="item.booking_status === 'close'">
                                {{ item.booking_closing_datetime | date }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </td>
                        <td class="caption text-second">
                          <v-list-item class="pa-0">
                            <v-list-item-content v-if="Object.keys(item.transaction_down_payment_status).length < 1">
                              <v-list-item-title class="caption text-third mb-1">
                                -
                              </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-content v-if="Object.keys(item.transaction_down_payment_status).length > 0">
                              <v-list-item-title class="caption orange--text mb-1">
                                {{ parseInt(item.transaction_down_payment_status.cash_tempo_value) | price }}
                              </v-list-item-title>
                              <v-list-item-subtitle class="text-third" style="font-size: 10px;">
                                Jatuh Tempo - {{ item.transaction_down_payment_status.cash_tempo_due_date | date }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </td>
                        <td class="caption text-second">
                          <v-list-item class="pa-0" v-if="item.transaction_payment_type === 'KPR'">
                            <v-list-item-content>
                              <v-list-item-title class="caption teal--text mb-1">
                                {{ item.status_mortage ? item.status_mortage : '-' }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <span v-if="item.transaction_payment_type === 'Cash'">
                            {{ item.transaction_payment_type }}
                          </span>
                        </td>
                        <td class="caption text-second">
                          <v-list-item class="pa-0">
                            <v-list-item-content>
                              <v-list-item-title class="caption red--text mb-1">
                                {{ item.status_developer ? item.status_developer : '-' }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-skeleton-loader>
              <v-row justify="center" align="center" v-if="!process.run && pagination.cancel.total_page < 1">
                <v-col cols="12" class="d-flex align-center my-12">
                  <v-img 
                    class="my-12"
                    contain
                    width="200"
                    height="200"
                    :src="require('../../../assets/404/404.svg')">
                  </v-img>
                </v-col>
              </v-row>
              <v-divider style="margin-top:3px;"/>
            </v-card-text>
            <v-card-text>
              <v-row justify="end" align="center" v-if="pagination.cancel.total_page > 1">
                <v-col cols="12" md="2" class="d-flex align-center justify-end">
                  <v-btn
                    :color="style.primary"
                    :disabled="pagination.cancel.current === 1"
                    elevation="3"
                    min-width="36"
                    class="text-capitalize white--text px-0 mr-3"
                    @click="selected.pagination.cancel = 1">
                    <v-icon>mdi-chevron-double-left</v-icon>
                  </v-btn>
                  <v-btn
                    color="#263238"
                    :disabled="pagination.cancel.current < 2"
                    elevation="3"
                    min-width="36"
                    class="text-capitalize white--text px-0"
                    @click="selected.pagination.cancel = selected.pagination.cancel-1">
                    <v-icon>mdi-chevron-left</v-icon>
                  </v-btn>
                  <div class="mx-5" style="width: 75px;">
                    <v-autocomplete
                      v-model="selected.pagination.cancel"
                      :items="pagination.cancel.detail"
                      color="#263238"
                      auto-select-first
                      outlined
                      dense
                      single-line
                      hide-details
                      hide-selected>
                      <template v-slot:selection="{ item }">
                        {{ item }}
                      </template>
                    </v-autocomplete>
                  </div>
                  <v-btn
                    color="#263238"
                    elevation="3"
                    min-width="36"
                    class="text-capitalize white--text px-0"
                    :disabled="pagination.cancel.current >= pagination.cancel.total_page"
                    @click="selected.pagination.cancel = selected.pagination.cancel+1">
                    <v-icon>mdi-chevron-right</v-icon>
                  </v-btn>
                  <v-btn
                    :color="style.primary"
                    :disabled="pagination.cancel.current === pagination.cancel.total_page"
                    elevation="3"
                    min-width="36"
                    class="text-capitalize white--text px-0 ml-3"
                    @click="selected.pagination.cancel = pagination.cancel.total_page">
                    <v-icon>mdi-chevron-double-right</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </div>
        </v-card>

        <!-- INFORMASI PROYEK -->
        <v-card
          min-height="785"
          class="border-radius box-shadow"
          style="border-radius: 0px 10px 10px 10px !important;"
          v-if="selected.menu > 0 && Object.keys(detail).length > 0">
          <v-skeleton-loader
            class="ma-auto"
            v-for="i in process.subscribe ? 5 : 1"
            :key="i"
            :loading="process.subscribe"
            transition="scale-transition"
            :tile="false"
            type="article">
            <div>
              <div v-if="!process.subscribe && Object.keys(subscribe).length > 0">
                <v-card-subtitle class="caption text-third pb-0">
                  Proyek
                </v-card-subtitle>
                <v-card-title class="subtitle-1 py-0">
                  {{ detail.name }}
                </v-card-title>
                <v-card-subtitle class="body-2 text-second line-text-second pt-6 pb-0">
                  {{ detail.address }}
                  <p class="mb-0">
                    {{ detail.city_name }}, {{ detail.province_name }}
                  </p>
                </v-card-subtitle>
                <v-divider class="mx-4 my-3"/>
                <v-card-text class="body-2 font-weight-bold text-second pt-1">
                  Informasi :
                </v-card-text>
                <v-card-text class="body-2 text-second py-0">
                  <p class="mb-2">
                    <v-icon small class="mr-1">mdi-check</v-icon>
                    <span>
                      Terjual {{ subscribe.project_unit_sold }} Unit
                    </span>
                  </p>
                  <p class="mb-2">
                    <v-icon small class="mr-1">mdi-check</v-icon>
                    <span>
                      Tersedia {{ subscribe.project_unit_available }} Unit
                    </span>
                  </p>
                </v-card-text>
                <v-card-text class="body-2 font-weight-bold text-second">
                  Status :
                </v-card-text>
                <v-card-text class="body-2 text-second py-0">
                  <p class="mb-2">
                    <v-icon small class="mr-1">mdi-check</v-icon>
                    <span>
                      {{ subscribe.company_project_is_trial === '0' ? 'Berlangganan' : 'Trial' }}
                    </span>
                  </p>
                  <p class="mb-2">
                    <v-icon small class="mr-1">mdi-check</v-icon>
                    <span>
                      {{ subscribe.company_project_schema_label }} 
                      ({{ subscribe.company_project_schema_type === 'unit' ? '1' : subscribe.company_project_schema_quota }} Unit) - 
                      <span v-if="parseInt(subscribe.company_project_schema_price) > 0">
                        {{ parseInt(subscribe.company_project_schema_price) | price }}
                      </span>
                      <span v-else>
                        Gratis
                      </span>
                    </span>
                  </p>
                  <p class="mb-2">
                    <v-icon small class="mr-1">mdi-check</v-icon>
                    <span>
                      Per Unit {{ (parseInt(subscribe.company_project_schema_price) / parseInt(subscribe.company_project_schema_quota)) | price}}
                    </span>
                  </p>
                  <p class="mb-2" :class="subscribe.company_project_is_active === '0' ? 'red--text' : ''">
                    <v-icon small class="mr-1" :color="subscribe.company_project_is_active === '0' ? 'red' : ''">mdi-check</v-icon>
                    <span>
                      {{ subscribe.company_project_is_active === '0' ? 'Layanan Tidak Aktif' : 'Layanan Aktif' }}
                    </span>
                  </p>
                  <p class="mb-2" v-if="subscribe.company_project_schema_type === 'unit'">
                    <v-icon small class="mr-1">mdi-check</v-icon>
                    <span>
                      {{ parseInt(subscribe.project_unit_total) }} Unit x 
                      {{ parseInt(subscribe.company_project_schema_price) | price }}
                    </span>
                  </p>
                  <p class="font-weight-bold mb-2" v-if="subscribe.company_project_schema_type === 'unit'">
                    <v-icon small class="mr-1">mdi-check</v-icon>
                    <span>
                      Total {{ (parseInt(subscribe.project_unit_total) * parseInt(subscribe.company_project_schema_price)) | price }}
                    </span>
                  </p>
                </v-card-text>

                <v-card-text class="body-2 text-second line-text-second pb-0" v-if="subscribe.company_project_schema_type !== 'unit' && user.company_type === 'external'">
                  <v-row>
                    <v-col cols="12" md="8">
                      <p class="mb-2 font-italic" v-if="(user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator')) && subscribe.company_project_is_active === '0'">
                        *Jika anda belum membayar untuk masa aktif proyek <b>{{ detail.name }}</b>, silahkan klik tombol dibawah ini :
                      </p>

                      <!-- <p class="mb-2 font-italic" v-if="(user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator')) && subscribe.company_project_is_active === '1'">
                        *Upgrade paket anda dan dapatkan kuota unit lebih banyak untuk proyek <b>{{ detail.name }}</b>, silahkan klik tombol dibawah ini :
                      </p> -->
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="ma-2" v-if="(user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator')) && subscribe.company_project_schema_type !== 'unit'">
                  <v-btn v-if="subscribe.company_project_is_active === '0'"
                    :color="style.primary"
                    elevation="3"
                    class="body-2 text-capitalize white--text px-4"
                    to="/invoice">
                    <v-icon small class="mr-1">mdi-credit-card-check-outline</v-icon>
                    Bayar Tagihan
                  </v-btn>

                  <!-- <v-btn v-if="subscribe.company_project_is_active === '1'"
                    color="orange"
                    elevation="3"
                    class="body-2 text-capitalize white--text px-4"
                    @click="dialog.payment.upgrade = true">
                    <v-icon small class="mr-1">mdi-credit-card-check-outline</v-icon>
                    Upgrade Paket
                  </v-btn> -->
                </v-card-actions>
              </div>
            </div>
          </v-skeleton-loader>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../service/Axios";
  import moment from 'moment';
  export default {
    data () {
      return {
        dateNow: moment().format('Y-MM-DD HH:mm:ss'),
        dialog: {
          unit: false,
          transaction: false,
          images: false,
          map: false,
          delete: false,
          other: false,
          discount: false,
          payment: {
            extend: false,
            upgrade: false
          }
        },
        selected: {
          menu: 0,
          subMenu: 0,
          pagination: {
            unit: 1,
            transaction: 1,
            cancel: 1
          }
        },
        config: {
          schema: []
        },
        menu: ['Tipe Unit', 'Berlangganan'],
        subMenu: ['Tersedia', 'Transaksi', 'Dibatalkan'],
        picker: {
          tempo: false,
          pay: false
        },
        center: {
          lat: 0,
          lng: 0
        },
        detail: {},
        filter: {
          title: '',
          type: '',
          discount: '',
          down_payment: '',
          mortage: '',
          developer: ''
        },
        autocomplete: {
          unit: '',
          customer: '',
          add: false
        },
        list: {
          unit: [],
          transaction: [],
          cancel: []
        },
        unit: [],
        detailUnit: {},
        customer: [],
        subscribe: {},
        pagination: {
          unit: {},
          transaction: {},
          cancel: {}
        },
        totalpage: {
          unit: '',
          transaction: '',
          cancel: '',
        },
        bank: [],
        form: {
          project_name: '',
          unit_id: '',
          marketing_id: '',

          payment_type: 'KPR',

          // USER / CUSTOMER
          user: {},
          user_name: '',
          user_mobilephone: '',
          user_email: '',
          user_ktp: '',
          user_address: '',

          // BANK
          bank_kpr: '',
          bank_kpr_branch: '',

          // PRICE
          price_sale: 0,
          price_kpr: 0,
          price_other: {
            price: 0,
            installments: 0,
            desc: ''
          },
          price_booking_fee: 0,
          price_fee: 0, // UANG MUKA
          price_fee_customer: 0, // TOTAL BAYAR KONSUMEN
          price_fee_total: 0, // TOTAL UANG MUKA,
          discount_value: 0, // DISKON
          price_discount: [{
            id: 0,
            title: '',
            price: 0,
            desc: ''
          }],

          count_dp: 0,

          // DESC
          order_message: '',
          duedate: '',
          paydate: '',
          desc: ''
        },
        payment: {
          project_id: '',
          schema_id: '',
          schema_desc: '',
          schema_price: '',
          duration: ''
        },
        process: {
          run: false,
          auto: false,
          form: false,
          subscribe: false,
          extend: false,
          upgrade: false
        },
        error: {
          message: ''
        },
        style: {
          primary: "#8BC541"
        }
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      }
    },
    watch: {
      'selected.menu': function(val) {
        this.selected.subMenu = 0
        
        if (val < 1) {
          this.fetchUnit()
        } else {
          // Langganan
          this.fetchSubscribe()
        }
      },
      'selected.subMenu': function(val) {
        this.filter.title = ''
        this.filter.type = ''
        
        if (val === 0) {
          this.fetchUnit()
        } else if (val === 1) {
          this.fetchTransaction()
        } else if (val === 2) {
          this.fetchCancel()
        }
      },
      'filter.type': function(val) {
        this.selected.pagination = {
          unit: 1,
          transaction: 1,
          cancel: 1
        }
        if (this.selected.subMenu === 0) {
          this.fetchUnit()
        } else if (this.selected.subMenu === 1) {
          this.fetchTransaction()
        } else if (this.selected.subMenu === 2) {
          this.fetchCancel()
        }
      },
      'autocomplete.unit': function(val) {
        this.auto().unit()
      },
      'autocomplete.customer': function(val) {
        this.auto().customer()
      },
      'form.user': function(val, oldval) {
        if (val !== undefined) {
          this.form.user = val
          this.form.user_name = val.user_name
          this.form.user_mobilephone = val.user_mobilephone
          this.form.user_email = val.user_email
          this.form.user_ktp = val.user_ktp
        } else {
          this.form.user = {}
          this.form.user_name = ''
          this.form.user_mobilephone = ''
          this.form.user_email = ''
          this.form.user_ktp = ''
        }
      },
      'selected.pagination.unit': function(val) {
        this.fetchUnit(val)
      },
      'selected.pagination.transaction': function(val) {
        this.fetchTransaction(val)
      },
      'selected.pagination.cancel': function(val) {
        this.fetchCancel(val)
      },
      'form.payment_type': function(val) {
        this.form.bank_kpr = ''
        this.form.bank_kpr_branch = ''
        this.form.price_kpr = 0
        this.form.price_other = {
          price: 0,
          installments: 0,
          desc: ''
        }
        this.form.price_booking_fee = 0
        this.form.price_fee = 0
        this.form.price_fee_customer = 0
        this.form.price_fee_total = 0
        this.form.discount_value = 0
        this.form.price_discount = [{
          id: 0,
          title: '',
          price: 0,
          desc: ''
        }]
        this.form.count_dp = 0
      },
      'form.price_kpr': function(val) {
        this.form.price_fee = parseInt(this.form.price_sale) - parseInt(val)
        this.form.price_fee_total = parseInt(this.form.price_fee) - parseInt(this.form.discount_value) - parseInt(this.form.price_booking_fee)

        this.form.price_fee_customer = parseInt(this.form.price_fee_total) + parseInt(this.form.price_other.price)
      },
      'form.price_fee': function(val) {
        if (this.form.payment_type === 'Cash') {
          let cash = parseInt(this.form.price_sale) - parseInt(val)
          this.form.price_fee_total = cash

          this.form.price_fee_customer = parseInt(this.form.price_fee_total) + parseInt(this.form.price_other.price)
        }
      },
      'form.discount_value': function(val) {
        if (this.form.payment_type === 'KPR') {
          this.form.price_fee_total = parseInt(this.form.price_fee) - parseInt(this.form.price_booking_fee) - parseInt(val)

          this.form.price_fee_customer = parseInt(this.form.price_fee_total) + parseInt(this.form.price_other.price)
        } else {
          this.form.price_fee_total = parseInt(this.form.price_sale) - parseInt(this.form.price_fee) - parseInt(this.form.price_booking_fee) - parseInt(val)
          
          this.form.price_fee_customer = parseInt(this.form.price_fee_total) + parseInt(this.form.price_other.price)
        }
      },
      'form.price_booking_fee': function(val) {
        if (this.form.payment_type === 'KPR') {
          this.form.price_fee_total = parseInt(this.form.price_fee) - parseInt(this.form.discount_value) - parseInt(val)

          this.form.price_fee_customer = parseInt(this.form.price_fee_total) + parseInt(this.form.price_other.price)
        } else {
          this.form.price_fee_total = parseInt(this.form.price_sale) - parseInt(this.form.price_fee) - parseInt(this.form.discount_value) - parseInt(val)
          
          this.form.price_fee_customer = parseInt(this.form.price_fee_total) + parseInt(this.form.price_other.price)
        }
      },
      'form.price_other.price': function(val) {
        this.form.price_fee_customer = parseInt(this.form.price_fee_total) + parseInt(val)
      },
      'payment.schema_id': function() {
        let t = this
        let s = this.config.schema.filter(function(v) {
          return t.payment.schema_id == v.schema_id
        })

        if (s.length > 0) {
          if (t.payment.schema_id === '1') {
            this.payment.schema_desc = `Jika anda memilih paket satuan, maka jumlah unit yang terbuat atau sejumlah ${t.subscribe.project_unit_total} unit akan dikalikan dengan harga satuan unit Rp 250.000.`
          } else {
            this.payment.schema_desc = s[0].schema_desc
          }

          this.payment.schema_price = parseInt(s[0].schema_price)
        }
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      fetch() {
        this.process.run = true
        get(`auth/company/project/resume`, {
          params: {
            id: this.$route.params.id
          }
        })
        .then(response => {
          let res = response.data
          if (res.status == 200) {
            this.detail = res.data
            this.center = {
              lat: this.detail.detail.coordinate.latitude,
              lng: this.detail.detail.coordinate.longitude
            }

            this.detail.unit_filter = [{
              unit_type_id: '',
              unit_type_name: 'Semua Tipe Unit'
            }]

            let data = res.data.unit_type

            for(let i in data) {
              this.detail.unit_filter.push({
                unit_type_id: data[i].unit_type_id,
                unit_type_name: data[i].unit_type_name
              })
            }

            this.fetchUnit()
            this.fetchTransaction()
            this.fetchCancel()
            this.fetchBank()
          }
        })
      },
      async fetchUnit(p) {
        this.process.run = true

        let params = {
          page: p,
          limit: 7,
          project_id: this.$route.params.id,
          unit_type_id: this.filter.type,
          search: this.filter.title,
          status: 'available'
        }

        await get(`auth/company/project/list-unit`, { params })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.process.run = false
            this.list.unit = res.data.results
            this.pagination.unit = res.data.pagination
            this.pagination.unit.current = parseInt(this.pagination.unit.current)
            this.totalpage.unit = `${this.pagination.unit.total_data} Unit`
          }
        })
      },
      async fetchSubscribe() {
        this.process.subscribe = true

        let params = {
          project_id: this.$route.params.id
        }

        await get(`auth/project/subscribe/status`, { params })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.process.subscribe = false
            this.subscribe = res.data

            this.payment.project_id = this.subscribe.project_id

            this.setting().schema()
          }
        })
      },
      async fetchTransaction(p) {
        this.process.run = true

        let params = {
          page: p,
          limit: 7,
          project_id: this.$route.params.id,
          unit_type_id: this.filter.type,
          search: this.filter.title,
          status_down_payment: this.filter.down_payment,
          status_mortage: this.filter.mortage,
          status_developer: this.filter.developer,
          status_discount_review: this.filter.discount
        }

        await get(`auth/company/project/list-unit-transaction`, { params })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.process.run = false
            this.list.transaction = res.data.results
            this.pagination.transaction = res.data.pagination
            this.pagination.transaction.current = parseInt(this.pagination.transaction.current)
            this.totalpage.transaction = `${this.pagination.transaction.total_data} Pembelian`
          }
        })
      },
      async fetchCancel(p) {
        this.process.run = true

        let params = {
          page: p,
          limit: 7,
          project_id: this.$route.params.id,
          unit_type_id: this.filter.type,
          search: this.filter.title
        }

        await get(`auth/company/project/list-unit-transaction-cancel`, { params })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.process.run = false
            this.list.cancel = res.data.results
            this.pagination.cancel = res.data.pagination
            this.pagination.cancel.current = parseInt(this.pagination.cancel.current)
            this.totalpage.cancel = `${this.pagination.cancel.total_data} Transaksi`
          }
        })
      },
      async fetchBank() {
        await get(`auth/company/bank-kpr/list-option`)
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.bank = res.data.results
          }
        })
      },
      auto() {
        let t = this
        return {
          async unit() {
            t.process.auto = true
        
            let params = {
              limit: 1000000,
              project_id: t.$route.params.id,
              search: t.autocomplete.unit,
              status: 'available',
              filter: [
                {
                  type: 'string',
                  field: 'unit_invoice_status',
                  value: 'approved',
                  comparison: '<>'
                }
              ]
            }

            get(`auth/company/project/list-unit`, { params })
            .then((response) => {
              let res = response.data
              if (res.status === 200) {
                t.process.auto = false
                t.unit = res.data.results
              }
            })
          },
          async customer() {
            t.process.auto = true
        
            let params = {
              limit: 10000,
              q: t.autocomplete.customer
            }

            get(`auth/sales/place-order/get-customer`, { params })
            .then((response) => {
              let res = response.data
              if (res.status === 200) {
                t.process.auto = false
                t.customer = res.data.result
              }
            })
          },
        }
      },
      setPlace(place) {
        this.center = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        }

        this.form.user_address = place.formatted_address
      },
      reset(item) {
        this.dialog.transaction = !this.dialog.transaction ? true : false
        
        this.form = { 
          project_name: this.detail.name,
          unit_id: item !== undefined ? item.unit_id : '',
          marketing_id: this.user.company_roles_id === '3' ? this.user.id : '',

          payment_type: 'KPR',

          // USER / CUSTOMER
          user: {},
          user_name: '',
          user_mobilephone: '',
          user_email: '',
          user_ktp: '',
          user_address: '',

          // BANK
          bank_kpr: '',
          bank_kpr_branch: '',

          // PRICE
          price_sale: item !== undefined ? parseInt(item.unit_price) : '',
          price_kpr: 0,
          price_other: {
            price: 0,
            installments: 0,
            desc: ''
          },
          price_booking_fee: 0,
          price_fee: 0, // UANG MUKA
          price_fee_customer: 0, // TOTAL BAYAR KONSUMEN
          price_fee_total: 0, // TOTAL UANG MUKA
          discount_value: 0, // DISKON
          price_discount: [{
            id: 0,
            title: '',
            price: 0,
            desc: ''
          }],

          count_dp: 0,

          // DESC
          duedate: '',
          paydate: '',
          order_message: '',
          desc: ''
        }

        this.process.run = false

        this.error.message = ''
      },
      addDiscount() {
        this.form.price_discount.push({
          id: 0,
          title: '',
          price: 0,
          desc: ''
        })
      },
      removeDiscount(index) {
        this.form.price_discount.splice(index, 1)
      },
      calculate() {
        let total = this.form.price_discount.reduce( ( sum, { price } ) => sum + price , 0)

        this.form.discount_value = total

        return total
      },
      onChange(e) {
        if (e !== undefined) {
          this.form.user = e
          this.form.user_name = e.user_name
          this.form.user_mobilephone = e.user_mobilephone
          this.form.user_email = e.user_email
          this.form.user_ktp = e.user_ktp
        } else {
          this.form.user = {}
          this.form.user_name = ''
          this.form.user_mobilephone = ''
          this.form.user_email = ''
          this.form.user_ktp = ''
        }
      },
      async save() {
        this.error.message = ''
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.run = true

          let forms = Object.assign({}, this.form)
          forms.duedate = moment().format('Y-MM-DD')
          forms.user = JSON.stringify(forms.user)
          forms.price_discount = JSON.stringify(forms.price_discount)
          forms.price_other = JSON.stringify(forms.price_other)

          await post(`auth/sales/place-order/add`, {
            data: forms
          }).then(response => {
            let res = response.data
            if (res.status === 200) {
              console.log('berhasil', res)
              this.process.run = false
              this.dialog.transaction = false
              this.selected.subMenu = 1
              this.autocomplete.add = false

              //window.open(res.data.url, '_blank')
              //window.open(res.data.url_other_price, '_blank')
              //window.open(res.data.url_utj, '_blank')
            } else {
              console.log('gagal', res)
              this.process.run = false
              this.error.message = res.msg
            }
          })
        }
      },
      async deletes() {
        this.error.message = ''
        this.process.run = true
        await post(`auth/company/project/delete`, {
          data: {
            id: JSON.stringify([this.detail.id])
          }
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            this.$router.push({ path: `/project` })
          } else {
            this.process.run = false
            this.error.message = res.msg
          }
        })
      },
      async prints() {
        this.process.form = true

        let params = {
          project_id: this.$route.params.id,
          search: this.filter.title
        }

        await get(`auth/report/canceled/export`, { params })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.process.form = false
            window.open(res.data.results.url, '_blank')
          }
          console.log('ini data res',res)
        })
      },
      setting() {
        let t = this
        return {
          async schema() {
            let params = {
              project_id: t.subscribe.project_id
            }

            get(`auth/project/subscribe/list-schema`, { params })
            .then(response => {
              let res = response.data;
              if (res.status == 200) {
                t.config.schema = res.data.results
              }
            })
          }
        }
      },
      async upgrade() {
        this.error.message = ''
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.upgrade = true

          this.payment.duration = this.payment.schema_id === '1' ? 1 : this.payment.duration

          await post(`auth/project/subscribe/upgrade-schema`, {
            data: this.payment
          }).then(response => {
            let res = response.data
            if (res.status === 200) {
              this.$router.push(`/invoice`)
            } else {
              this.process.upgrade = false
              this.error.message = res.msg
            }
          })
        }
      }
    }
  }
</script>

<style scoped>
._maps {
  width: 100%;
  height: 1000px;
}
</style>